module.exports = __webpack_public_path__ + "static/media/a-l-o-a-l-t-o-copy-2.d8ed59bd.svg";